<template>
	<div class="checkbox checkbox-switchery" :class="{ 'disabled': disabled }">
		<label :for="id" class="switch" @click="toggle">
			<input type="checkbox" :class="classes" :checked="checked">
			<span><slot></slot></span>
		</label>
	</div>
</template>

<script>
	export default {
		props: {
			id: {
				type: String,
				default: ''
			},
			disabled: {
				default: false,
				type: Boolean
			},
			classes: {
				default: () => []
			},
			value: {
				default: false
			},
			onValue: {
				default: true,
			},
			offValue: {
				default: false
			}
		},
		data() {
			return {
				internalValue: this.value
			};
		},
		computed: {
			checked() {
			    return _.isEqual(this.internalValue, this.onValue);
			}
		},
		methods: {
			/**
			 * Toggle the checked state
			 */
			toggle() {
				if (this.disabled) {
					return;
				}

				if (_.isEqual(this.internalValue, this.onValue)) {
					this.internalValue = this.offValue;
				} else {
					this.internalValue = this.onValue;
				}
			}
		},
		watch: {
		    value(value){
                this.internalValue = value;
			},
			internalValue(value) {
				this.$emit('input', value);
				this.$emit('click', value);
			}
		}
	}
</script>

<style lang="scss" scoped>
	div.disabled label.switch {
		input[type="checkbox"] {
			+ span {
				cursor: initial;

				&:before,
				&:after {
					cursor: initial;
				}
			}
		}
	}

	label.switch {
		padding-left: 0;

		input[type="checkbox"] {
			display: none;
			&:checked {
				+ span {
					&:before {
						background-color: rgba(#007feb, 0.5);
					}
					&:after {
						background-color: #007feb;
						transform: translate(80%, -50%);
					}
				}
			}
			+ span {
				position: relative;
				display: inline-block;
				cursor: pointer;
				font-weight: 500;
				text-align: left;
				margin: 0;
				padding: 0 44px;
				&:before,
				&:after {
					content: '';
					cursor: pointer;
					position: absolute;
					margin: 0;
					outline: 0;
					top: 50%;
					transform: translate(0, -50%);
					transition: all 200ms ease-out;
				}
				&:before {
					left: 1px;
					width: 34px;
					height: 14px;
					background-color: rgba(0, 0, 0, 0.2);
					border-radius: 8px;
				}
				&:after {
					left: 0;
					width: 20px;
					height: 20px;
					background-color: rgba(0, 0, 0, 0.5);
					border-radius: 50%;
					box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .14), 0 2px 2px 0 rgba(0, 0, 0, .098), 0 1px 5px 0 rgba(0, 0, 0, .084);
				}
			}
			&:checked + span &:after {
				transform: translate(80%, -50%);
			}
		}
	}
</style>